export default {
  onBoarding: { complete: false, step: 0 },
  home: { complete: false, step: 0 },
  clients: { complete: false, step: 0 },
  constructionsForm: { complete: false, step: 0 },
  payables: { complete: false, step: 0 },
  budgets: { complete: false, step: 0 },
  schedules: { complete: false, step: 0 },
  photos: { complete: false, step: 0 },
  documents: { complete: false, step: 0 },
  dashboard: { complete: false, step: 0 },
  suppliers: { complete: false, step: 0 },
  categories: { complete: false, step: 0 },
  newRelease: { complete: false, step: 0 },
};
